import ListingHighlights from './ListingHighlights.component';

export default ListingHighlights;
